import Footer from "../../../Pages/MainLayout/Footer/Footer";
import Headings from "../../../Pages/MainLayout/Headings/Headings";
import Line from "../../../Pages/MainLayout/Line/Line";
import "./CourseOutline.css";

import award from "../../../Assets/images/award.svg";
import calander from "../../../Assets/images/calendar.svg";
import corseclock from "../../../Assets/images/corseclock.svg";
import corsedesktop from "../../../Assets/images/corsedesktop.svg";
import corseright from "../../../Assets/images/corseright.svg";
import kitimg from "../../../Assets/images/kitimg.svg";
import leftarrow from "../../../Assets/images/left_arrow.svg";
import previmg from "../../../Assets/images/previmg.svg";
import refresh from "../../../Assets/images/refresh.svg";
import {
  default as arrowwhite,
  default as rightarrow,
} from "../../../Assets/images/rightarrow.svg";
import rong from "../../../Assets/images/rong.svg";
import support from "../../../Assets/images/support.svg";
import viewnow from "../../../Assets/images/viewnow.svg";
import watchnow from "../../../Assets/images/watchnow.svg";
import lockIcon from "../../../Assets/images/icons8-lock.svg";

import { useContext, useEffect, useState, useRef } from "react";
import { Button, CardFooter, Modal, ModalBody } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { API_URL, IMG_PATH } from "../../../server";

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import dayjs from "dayjs";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import NextAvailableSlot from "../../../Components/AvailableSlot/NextAvailableSlot"; // adjust the path as needed
import TutorCard from "../../../Components/tutorCard/tutorCard";
import { AppProvider } from "../../../ContextApi/AppContext";
import Loopsession from "../LoopSession/loopsession";
import CourseOutlineModule from "./CourseOutlineModule";
import corsevideo from "../../../Assets/images/corsevideo.svg";
import "../LoopSession/loopsession.css";
import SettingSubscription from "../../SettingScreens/SettingSubscription/SettingSubscription";

const CourseOutline = () => {
  const { state, setState, prev, setPrev, index, setIndex } =
    useContext(AppProvider);
  const [modalname, setModalName] = useState("");
  const lastToastRef = useRef({ sessionKey: null, expertId: null, time: 0 });

  const [chooseExpertSession, setChooseExpertSession] = useState(false);

  // Add this state to track completed loops
  const [completedLoops, setCompletedLoops] = useState([]);
  // Add these states
  const [currentLoopId, setCurrentLoopId] = useState("");
  const [currentOutlineDetail, setCurrentOutlineDetail] = useState(null);
  // Add this state to track selected tutors for each session
  const [selectedTutors, setSelectedTutors] = useState({});

  const [calanderModal, setCalanderModal] = useState(false);
  const [outlinedetails, setOutlineDetails] = useState([]);
  const [outlinedetailscompleted, setOutlineDetailsCompleted] = useState([]);
  const [courseHighlets, setCourseHighlets] = useState([]);
  const [courseSessions, setCourseSessions] = useState([]);
  const [CoursecompletionRatio, setCoursecompletionRatio] = useState("");
  const [date, setDate] = useState(new Date());
  const [cardDetails, setCardDetails] = useState([]);
  const [totalExpertData, setTotalExpertData] = useState([]);
  const [courseId, setCourseId] = useState("");
  const [ansId, setAnsId] = useState("");
  const [particularExpertName, setParticularExpertName] = useState("");
  const [YourBadge, setYourBadge] = useState("");
  const [badgeMessage, setBadgeMessage] = useState("");

  const token = sessionStorage.getItem("token");
  const registerid = sessionStorage.getItem("registerid");
  const navigate = useNavigate();
  const loc = useLocation();

  const {
    subjectname,
    courseName,
    subid,
    coursename,
    accept_badge_url,
    duration,
    courseDescription,
    courseOneLiner,
    courseSession,
  } = loc?.state;

  const days = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];

  const [disabledDays, setDisabledDays] = useState([]);
  const [selectedDate, setSelectedDate] = useState(date);
  const [expertId, setExpertId] = useState("");
  const parsedDate = new Date(selectedDate);
  const [daySlots, setDaySlots] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [selectedInputIndex, setSelectedInputIndex] = useState(null);
  const [subjectExpertId, setsubjectexpertid] = useState("");

  const [signout, setSignout] = useState(false);
  const [bookingIdToCancel, setBookingIdToCancel] = useState(null);
  const [hideSlots, setHideSlots] = useState([]);

  const [filteredCourse, setfilteredCourse] = useState([]);
  const [sessionloop, setSessionloop] = useState(false);
  const [loopSession, setLoopSession] = useState([]);

  const [subscriptionModal, setSubscriptionModal] = useState(false);
  const [userDetails, setUserDetails] = useState(null);

  // Load completed loops from localStorage on component mount
  useEffect(() => {
    const savedCompletedLoops = localStorage.getItem("completedLoops");
    if (savedCompletedLoops) {
      setCompletedLoops(JSON.parse(savedCompletedLoops));
    }
  }, []);

  // Load selected tutors from localStorage on component mount
  useEffect(() => {
    const savedSelectedTutors = localStorage.getItem("selectedTutors");
    if (savedSelectedTutors) {
      setSelectedTutors(JSON.parse(savedSelectedTutors));
    }
  }, []);

  // Save to localStorage whenever selectedTutors changes
  useEffect(() => {
    localStorage.setItem("selectedTutors", JSON.stringify(selectedTutors));
  }, [selectedTutors]);

  // Save to localStorage whenever completedLoops changes
  useEffect(() => {
    localStorage.setItem("completedLoops", JSON.stringify(completedLoops));
  }, [completedLoops]);

  // Function to mark loop as completed

  useEffect(() => {
    mydetails();
  }, []);

  const mydetails = async () => {
    try {
      const response = await fetch(API_URL + "getUsers", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({ _id: registerid }),
      });

      const result = await response.json();
      console.log("getUsers", result);

      setUserDetails(result.data.profile);
    } catch (error) {
      console.error(error);
    }
  };

  const isSubscribed = userDetails?.subscription;

  // const handleOpenTutorModal = () => {
  //   if (isSubscribed) {
  //     setChooseExpertSession(true)
  //   } else {
  //     setSubscriptionModal(true)
  //   }
  // }

  const handleOpenTutorModal = () => {
    if (!registerid) {
      window.dispatchEvent(new Event("recess:openSignIn"));
      navigate("/", { state: true });
      return;
    }
    if (isSubscribed) {
      setChooseExpertSession(true);
    } else {
      setSubscriptionModal(true);
    }
  };

  const requireSubscriptionOnly = () => {
    if (!isSubscribed) {
      setSubscriptionModal(true); // 🔓 show subscription popup
      return false;
    }
    return true;
  };

  // Function to mark loop as completed
  // const handleLoopComplete = loopId => {
  //   setCompletedLoops(prev => [...prev, loopId])
  // }

  // const handleLoopComplete = (loopId) => {
  //   setCompletedLoops((prev) => {
  //     const updated = [...new Set([...prev, loopId])];

  //     // ✅ TURN CARD GREEN AFTER FIRST LOOP COMPLETION
  //     // markCourseGreen();

  //     return updated;
  //   });
  // };

  const handleLoopComplete = (loopId) => {
    setCompletedLoops((prev) =>
      prev.includes(loopId) ? prev : [...prev, loopId],
    );

    setOutlineDetails((prev) =>
      prev.filter((od) => getSessionKeyFromOD(od) !== loopId),
    );

    setOutlineDetailsCompleted((prev) => {
      const completedItem = outlinedetails.find(
        (od) => getSessionKeyFromOD(od) === loopId,
      );
      return completedItem ? [...prev, completedItem] : prev;
    });
  };

  // const handleLoopComplete = (loopId) => {
  //   const sessionKey = getSessionKeyFromOD(loopId);
  //   if (!sessionKey) return;

  //   setCompletedLoops(prev => {
  //     const updated = [...new Set([...prev, sessionKey])];
  //     markCourseGreen();
  //     return updated;
  //   });
  // };

  // Function to restart a loop
  const handleRestartLoop = (loopId) => {
    setCompletedLoops((prev) => prev.filter((id) => id !== loopId));
  };



  const isCompleted = (ratio) => {
  if (!ratio) return false
  const [done, total] = ratio.split("/")
  return Number(done) === Number(total)
}
  const handleViewBadge = () => {
    if (!registerid) {
      window.dispatchEvent(new Event("recess:openSignIn"));
      navigate("/", { state: true });
      return;
    }

    if (!isCourseCompleted(CoursecompletionRatio)) {
      setBadgeMessage("Course is not completed");

      setTimeout(() => {
        setBadgeMessage("");
      }, 2500);

      return;
    }

    viewCertificate();
  };
  const autoSelectFirstTutor = (sessionKey) => {
    if (!sessionKey) return;
    if (!cardDetails || cardDetails.length === 0) return;

    // already selected → do nothing
    if (selectedTutors[sessionKey]) return;

    const firstTutor = cardDetails[0];

    const fullTutor = {
      ...firstTutor,
      expertId: firstTutor._id || firstTutor.user_id || "",
    };

    setSelectedTutors((prev) => {
      const updated = {
        ...prev,
        [sessionKey]: fullTutor,
      };
      localStorage.setItem("selectedTutors", JSON.stringify(updated));
      return updated;
    });
  };

  // const markCourseGreen = () => {
  //   if (!registerid) return;

  //   const key = `greenCourses_${registerid}`;

  //   const completed = JSON.parse(localStorage.getItem(key) || "[]");

  //   if (!completed.includes(courseId)) {
  //     completed.push(courseId);
  //     localStorage.setItem(key, JSON.stringify(completed));
  //   }
  // };

  const itemsPerPage = 8;
  const [storedValues, setStoredValues] = useState({});
  // console.log(storedValues);
  const totalPages = Math.ceil(daySlots[0]?.slots.length / itemsPerPage);
  const currentSlots = daySlots[0]?.slots.slice(
    currentPage * itemsPerPage,
    (currentPage + 1) * itemsPerPage,
  );
  const today = dayjs();
  const maxDate = today.add(1, "month").endOf("month");
  // const normalizedOutlinedetails = (outlinedetails || []).map((o) => ({
  //   ...o,
  //   _id: o._id || o?.Answer?.[0]?._id || null,
  // }));
  const normalizedOutlinedetails = (outlinedetails || []).map((o) => ({
  ...o,
  _id: o?.Answer?.[0]?._id || null,
}));

  useEffect(() => {
    if (!cardDetails.length) return;
    if (!outlinedetails.length) return;

    setSelectedTutors((prev) => {
      const updated = { ...prev };

      outlinedetails.forEach((od) => {
        const sessionKey = od?.Answer?.[0]?._id;;
        if (!sessionKey) return;

        // ⛔ already selected → skip
        if (updated[sessionKey]) return;

        const firstTutor = cardDetails[0];

        updated[sessionKey] = {
          ...firstTutor,
          expertId: firstTutor._id || firstTutor.user_id || "",
        };
      });

      localStorage.setItem("selectedTutors", JSON.stringify(updated));
      return updated;
    });
  }, [cardDetails, outlinedetails]);

  useEffect(() => {
    getCardDetails();
    chooseExpert();
    const today = dayjs().format("YYYY-MM-DD");
    setSelectedDate(today);
  }, []);
  useEffect(() => {
    getExpertSettingById(subjectExpertId);
    setCurrentPage(0);
    setSelectedInputIndex(null);
  }, [selectedDate]);
  const openSignoutModal = (bookingid) => {
    setBookingIdToCancel(bookingid);
    setSignout(true);
  };
  const closeSignoutModal = () => {
    setSignout(false);
    setBookingIdToCancel(null);
  };
  const handleNext = () => {
    if (currentPage < totalPages - 1) {
      setCurrentPage((prev) => prev + 1);
      setSelectedInputIndex(null);
    }
  };
  const handlePrev = () => {
    if (currentPage > 0) {
      setCurrentPage((prev) => prev - 1);
      setSelectedInputIndex(null);
    }
  };
  const handleInputClick = (index, value) => {
    setSelectedInputIndex(index);
    setStoredValues(value);
  };
  // slots related functionality ended

  const getCardDetails = () => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", "Bearer " + token);

    const raw = JSON.stringify({
      user_id: registerid,
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(API_URL + "getAllCourse", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.Status == true) {
          console.log("getAllCourse", result);
          const filteredCourses = result?.data?.courses?.filter(
            (course) => course.courseName == courseName,
          );
          console.log("filteredCoursetttttcourseSe", filteredCourses);
          setfilteredCourse(filteredCourses);
          setCourseId(filteredCourses[0]._id);
          // setYourBadge(filteredCourses[0].accept_badge_url);
          if (filteredCourses?.length > 0) {
            setYourBadge(filteredCourses[0]?.accept_badge_url);
          }
          setCourseHighlets(filteredCourses[0].courseHighlights);
          setCourseSessions(filteredCourses[0].courseSession);
          setCoursecompletionRatio(filteredCourses[0].completionRatio);

          console.log("setCourseSessions", filteredCourses[0].courseSession);
          console.log("Course Highlights RAW:", filteredCourses[0].courseHighlights);

          const odc = filteredCourses[0].course.filter(
            (cour) => cour.Answer[0]?.bookings[0]?.isCourseCompleted == "true",
          );
          const od = filteredCourses[0].course.filter(
            (cour) =>
              cour.Answer[0]?.bookings[0]?.isCourseCompleted == "pending" ||
              cour.Answer[0]?.bookings?.length === 0,
          );
          console.log(odc, "odc");
          console.log("oddddddddddddddddd", od);
          setOutlineDetailsCompleted(odc);
          setOutlineDetails(od);
        }
      })
      .catch((error) => console.error(error));
  };

  

  const cancelBooking = (bookingid) => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", "Bearer " + token);

    const raw = JSON.stringify({
      user_id: registerid,
      booking_id: bookingid,
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(API_URL + "cancelBooking", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        console.log("cancelBooking", result);
        closeSignoutModal();
        getCardDetails();
      })
      .catch((error) => console.error(error));
  };

  const chooseExpert = () => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", "Bearer " + token);

    const raw = JSON.stringify({
      user_id: registerid,
      mySubject: subjectname,
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(API_URL + "getMySubjectById", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.Status === true) {
          console.log("Tutor API record:", result.data);
          setCardDetails(result.data);
        }
      })
      .catch((error) => console.error(error));
  };

  const convertMinutesToHours = (minutes) => {
    if (!minutes || minutes <= 0) return "0 min"; // Handle edge cases

    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;

    if (hours > 0 && mins > 0) {
      return `${hours} hour ${mins} min course`;
    } else if (hours > 0) {
      return `${hours} - hour course`;
    } else {
      return `${mins} - min course`;
    }
  };

  const getExpertSettingById = (exid) => {
    setsubjectexpertid(exid);
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", "Bearer " + token);

    const raw = JSON.stringify({
      expert_id: exid,
    });
    console.log("exp", raw);
    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(API_URL + "getExpertSettingById", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.Status === true) {
          console.log("getExpertSettingById", result);
          setTotalExpertData(result.data);
          const disableddays = result.data.newTiming
            .filter((day) => day.slots.some((slot) => !slot.isBooked))
            .map((day) => day.day);
          setDisabledDays(disableddays);
          const filterdayslots = result.data.newTiming.filter(
            (sloat) =>
              sloat.day === days[parsedDate.getDay()] ||
              sloat.day === days[parsedDate.getDay()].substring(0, 3),
          );
          const filterdates01 = result.data.courseBooking.filter(
            (booking) => booking.chooseDate.split("T")[0] === selectedDate,
          );
          const filterdates02 = result.data.bookings.filter(
            (booking) => booking.chooseDate.split("T")[0] === selectedDate,
          );
          console.log(
            filterdates01,
            "=======",
            filterdates02,
            "========",
            selectedDate,
          );
          setHideSlots([
            ...filterdates01.map((items) => items.chooseTime),
            ...filterdates02.map((items) => items.chooseTime),
          ]);
          setDaySlots(filterdayslots);
        }
      })
      .catch((error) => console.error(error));
  };

  // Add this function to your CourseOutline component (around line 400)
  const startSessionloop = async (
    loopSession,
    subject,
    loopId,
    outlineDetail,
  ) => {
    if (registerid === null) {
      navigate("/", { state: true });
    } else {
      setLoopSession(loopSession);
      setLoopSubject(subject);
      setCurrentLoopId(loopId);
      setCurrentOutlineDetail(outlineDetail);

      // Remove from completed if restarting
      if (completedLoops.includes(loopId)) {
        setCompletedLoops((prev) => prev.filter((id) => id !== loopId));
      }

      // fetch subject tools
      const subjectObj = await allSubjects(subject);
      const subjectKeytools = subjectObj?.subject_tool || [];
      setFilteredKeytools(subjectKeytools);

      setSessionloop(true);
    }
  };

  const bookexpert = () => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", "Bearer " + token);

    const raw = JSON.stringify({
      user_id: registerid,
      expert_id: expertId,
      courseId: courseId,
      answerId: ansId,
      type: "Video",
      amount: totalExpertData?.amount,
      chooseDate: selectedDate,
      chooseTime: storedValues,
      day: days[parsedDate.getDay()],
    });
    console.log(raw, "raw");
    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(API_URL + "courseBookExpert", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.Status === true) {
          console.log("courseBookExpert", result);
          toast?.success(result?.message);
          setTimeout(() => {
            navigate("/CardCourses");
          }, 2000);
        } else {
          toast.error(result?.message, {
            autoClose: 2000,
            onClose: () => {
              if (
                result?.message ==
                "Insufficient session count in wallet. Please recharge your wallet."
              ) {
                navigate("/SettingsMainScreen/SettingWallet", {
                  state: 6,
                });
              }
            },
          });
        }
      })
      .catch((error) => console.error(error));
  };

  const handleAddToCalendar = (ups) => {
    console.log("calendar", ups);

    const date = new Date(ups.chooseDate);
    const formattedDate = date.toISOString().split("T")[0]; // Format as YYYY-MM-DD
    console.log("formattedDate", formattedDate);

    // Convert the formatted date to YYYYMMDD format for Google Calendar
    const startDate = formattedDate.replace(/-/g, ""); // Replace dashes to match Google Calendar format
    const endDate = startDate;
    // Extract the date and time from the API response
    const eventTitle = encodeURIComponent(
      `${ups?.name?.trim()} - ${ups?.preferredSessionType} Session`,
    );
    const eventDetails = encodeURIComponent(
      `Join this session with ${ups?.name?.trim()}. Session type: ${
        ups?.preferredSessionType
      }. Amount: ${ups?.amount}.`,
    );
    const location = encodeURIComponent("Online"); // Replace with actual location if available

    // Construct the Google Calendar URL
    const calendarUrl = `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${eventTitle}&dates=${startDate}/${endDate}&details=${eventDetails}&location=${location}`;

    // Open the link in a new tab to allow the user to add the event
    window.open(calendarUrl, "_blank");
  };

  const ContactSupport = (num) => {
    navigate("/SettingContentSupport");
    //   navigate("/SettingsMainScreen/SettingContentSupport", {
    //   state: num,
    // });
  };

  const watchNow = (data) => {
    navigate("/RecordingScreen", {
      state: data,
    });
  };

  // const viewCertificate = () => {
  //   window.open(
  //     "https://sandbox.credly.com/badges/65654f17-82f6-4f4a-bb27-2ff2259eb999/accept",
  //   );
  // };
  const viewCertificate = () => {
    console.log("YourBadge URL:", YourBadge);
    if (YourBadge) {
      console.log("Opening badge URL:", YourBadge);
      window.open(YourBadge, "_blank"); 
    }
  };

  const navigateToSubject = (subject) => {
    const subjectName = filteredCourse?.filter((course) =>
      course.mySubject.includes(subject),
    );

    // navigate('/Subject_bookmark', { state: { subject } })
    navigate("/Flowsubjectdetails", { state: { subject } });
  };



  const isCourseCompleted = (completionRatio) => {
    if (!completionRatio || !completionRatio.includes("/")) return false;

    const [completed, total] = completionRatio.split("/").map(Number);

    if (isNaN(completed) || isNaN(total) || total === 0) return false;

    return completed === total;
  };

  const roundRatio = (completionRatio) => {
    // console.log("completionRatio", completionRatio);
    if (!completionRatio || !completionRatio.includes("/")) return 0; // Handle invalid cases
    const [completed, total] = completionRatio.split("/").map(Number);
    return total > 0 ? (completed / total) * 100 : 0; // Avoid division by zero
  };

  // In parent:
  const updateBookmarkInParent = (expertId) => {
    setCardDetails((prev) =>
      prev.map((item) =>
        item.user_id === expertId
          ? { ...item, isBookedMark: !item.isBookedMark }
          : item,
      ),
    );
  };

 

  const handleBookSession = (carddetail, od) => {
    // const sessionKey = getSessionKeyFromOD(od) || getSessionKeyFromOD(ansId); // ✅ fallback for completed loops
    const sessionKey = typeof od === "string"
  ? od
  : od?.Answer?.[0]?._id;
    if (!sessionKey) {
      console.error("No sessionKey found for tutor selection");
      return;
    }

    const fullTutor = {
      ...carddetail,
      expertId: carddetail?._id || carddetail?.user_id || "",
    };

    setSelectedTutors((prev) => {
      const updated = {
        ...prev,
        [sessionKey]: fullTutor,
      };
      localStorage.setItem("selectedTutors", JSON.stringify(updated));
      return updated;
    });

    setChooseExpertSession(false);
  };

  const [loopSubject, setLoopSubject] = useState(""); // store subject for modal

  // const startSessionloop = loopSession => {
  //   if (registerid === null) {
  //     navigate('/', { state: true })
  //   } else {
  //     setLoopSession(loopSession)
  //     setSessionloop(true)
  //   }
  // }
  const [filteredKeytools, setFilteredKeytools] = useState([]);
  // const getSessionKeyFromOD = (odOrAnsId) => {
  //   if (!odOrAnsId) return null;
  //   if (typeof odOrAnsId === "string") return odOrAnsId;
  //   return odOrAnsId._id || odOrAnsId?.Answer?.[0]?._id || null;
  // };
  const getSessionKeyFromOD = (odOrAnsId) => {
  if (!odOrAnsId) return null;

  if (typeof odOrAnsId === "string") return odOrAnsId;

  return odOrAnsId?.Answer?.[0]?._id || null;
};

  const allSubjects = async (subjectName) => {
    try {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + token);

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        redirect: "follow",
      };

      const response = await fetch(API_URL + "getAllSubject", requestOptions);
      const result = await response.json();

      const matchedSubject = result.data.find(
        (item) => item.subject?.toLowerCase() === subjectName?.toLowerCase(),
      );

      return matchedSubject || null;
    } catch (error) {
      console.error("Error fetching subjects:", error);
      return null;
    }
  };

  const getResolvedTutor = (odLike) => {
    const sessionKey = getSessionKeyFromOD(odLike);

    // 1️⃣ User-selected tutor (highest priority)
    if (sessionKey && selectedTutors[sessionKey]) {
      return selectedTutors[sessionKey];
    }

    // 2️⃣ Backend booked tutor (fallback)
    const booked = odLike?.Answer?.[0]?.bookings?.[0]?.expertDetails;
    if (booked) {
      return {
        ...booked,
        expertId: booked?._id || booked?.user_id || "",
      };
    }

    return null;
  };

  return (
    <div className="min-h-screen w-full bg-[#F5F3EE] flex flex-col w-m-xxl-auto">
      <div className="w-full">
        <Headings screenHeadingName="courses." />
        <ToastContainer />

        <div>
          <div className="bodyConatiner px-4 min-[600px]:px-2">
            <div className="w-full">
              {" "}
              <Line />
            </div>
            {/* leftContainer */}
            <div className="leftContainer">
              <dl>
                <div className="flex justify-between">
                  <h1 className="cotitle1">{coursename}</h1>
                  <span className="text-xs text-gray-800 font-medium m-2 w-6">
                    {isCompleted(CoursecompletionRatio) ? (
                      <div>
                        <img className="h-6 w-6" src={award} />
                      </div>
                    ) : (
                      <CircularProgressbar
                        strokeWidth={15}
                        maxValue={100} // Percentage scale
                        value={roundRatio(CoursecompletionRatio)}
                        styles={buildStyles({
                          pathColor: "#005230",
                        })}
                        size={15}
                      />
                    )}
                  </span>
                </div>

                {/* <p className='copara mt-1'>{courseOneLiner}</p> */}

                <div className="flex mt-1 justify-start align-items-start mb-2">
                  <lable className="copara me-4 d-flex align-items-center">
                    <img src={corseclock} className="me-1" />
                    {convertMinutesToHours(duration)}
                  </lable>
                  <label className="copara d-flex align-items-center">
                    <img src={corsedesktop} className="me-1" />
                    Desktop recommendeddd{" "}
                  </label>
                </div>

                <div className="hidden sm:block mb-4 ">
                  {/* <dt
                    className='copara mb-1 mt-4'
                    style={{
                      fontFamily: 'AvenirNextLTPro-Bold',
                      fontSize: '0.8rem'
                    }}
                  >
                    COURSE DESCRIPTION
                  </dt> */}

                  <p className="copara">{courseDescription}</p>
                </div>

                <hr className="coline mb-4" />
                <div
                  className="d-flex"
                  style={{
                    overflowX: "scroll",
                    maxWidth: "500px",
                    marginTop: "12px",
                    scrollbarWidth: "none",
                  }}
                >
                  {courseSessions?.map((csession, index) => (
                    <div key={index} className="ml-1 mb-1">
                      <button className="cobtn1 copara me-3">
                        {csession.split()}
                      </button>
                    </div>
                  ))}
                </div>

                <dt
                  className="copara mb-2 mt-4"
                  style={{
                    fontFamily: "AvenirNextLTPro-Bold",
                    fontSize: "0.8rem",
                  }}
                >
                  Course Highlights
                </dt>
                {/* {courseHighlets?.map((ch, index) => (
                  <div key={index}>
                    <dd className='copara d-flex align-items-center mb-2'>
                      <img src={corseright} className='me-2' />
                      {ch}
                    </dd>
                  </div>
                ))} */}
                {courseHighlets?.map((ch, index) => (
                  <div key={index}>
                    <dd className="copara d-flex align-items-center mb-2">
                      <img src={corseright} className="me-2" />
                      {ch.trim()}
                    </dd>
                  </div>
                ))}
                <hr className="coline mt-4 mb-4" />

                <div className="d-flex flex-column mt-3">
                  <button
                    className="cobtn2 d-flex ps-4 align-items-center"
                    onClick={() => navigateToSubject(subjectname)}
                  >
                    {subjectname}{" "}
                    <img
                      src={rightarrow}
                      style={{ height: "0.9rem", width: "0.9rem" }}
                      className="ms-auto me-3"
                    />
                  </button>
                  <button
                    onClick={() => navigate("/CardCourses")}
                    className="cobtn2 d-flex ps-4 align-items-center"
                  >
                    <img
                      src={leftarrow}
                      style={{ height: "0.9rem", width: "0.9rem" }}
                      className="me-3"
                    />
                    Courses
                  </button>
                </div>
              </dl>
            </div>

            {/* rightContainer */}
            <div className="rightContainer ">
              <div
                className="coursekit  mb-4 mt-2"
                onClick={() => {
                  if (registerid === null) {
                    navigate("/", { state: true });
                  } else if (!isSubscribed) {
                    setSubscriptionModal(true);
                  } else {
                    setModalName("");
                    setTimeout(() => setModalName("coursekit"), 0);
                  }
                }}
              >
                <div className="d-flex justify-content-between align-items-center py-1 cursor-pointer">
                  {/* Left: kitimg and Course Kit */}
                  <div className="d-flex align-items-center gap-2 ">
                    <img
                      src={kitimg}
                      style={{ width: "1.2rem", height: "1.2rem" }}
                      alt="Kit"
                    />
                    <span className="cotitle2">Course Kit</span>
                  </div>

                  {/* Right: notiblack icon */}
                  <img
                    src={arrowwhite}
                    alt="Notification"
                    style={{ width: "1rem", height: "1rem" }}
                  />
                </div>
              </div>

              <hr className="coline mt-5 mb-4" />

              <h1 className="cotitle2">Course Outline</h1>
              <p className="copara mb-4 text-muted">
                You must complete each session to move on to the next. Feel free
                to book additional sessions with tutors for extra support
                anytime.
              </p>
              <div>
                {outlinedetailscompleted?.map((odc, index) => (
                  <div>
                    {/* <div className='courseprev mb-3'>
                      <div className='d-flex justify-content-between align-items-center'>
                        <span className='cosubtitle'>
                          Session {String(index + 1).padStart(2, '0')} Preview
                        </span>
                        <span>
                          <img
                            style={{ width: '1.1rem', height: '1.1rem' }}
                            src={previmg}
                          />
                        </span>
                      </div>
                      <hr className='coline mt-4 mb-4' />
                      <span
                        onClick={() => {
                          setIndex(String(index + 1).padStart(2, '0'))
                          setPrev(odc?.preview)
                          setModalName('')
                          setTimeout(() => setModalName('preview'), 0)
                        }}
                        style={{
                          cursor: 'pointer',
                          fontFamily: 'AvenirNextLTPro-Bold',
                          fontSize: '0.7rem'
                        }}
                        className='copara ms-2 d-flex align-items-center'
                      >
                        View now{' '}
                        <img
                          style={{ width: '0.6rem', height: '0.6rem' }}
                          src={rightarrow}
                        />
                      </span>
                    </div> */}
                    <div
                      key={index}
                      style={{
                        backgroundColor: "#E5ECE3",
                        borderRadius: "8px",
                        border: "1px solid #D0D0D0",
                      }}
                      className="mb-3 p-4"
                    >
                      <div className="d-flex justify-content-between">
                        <div className="cosubtitle d-flex align-items-center">
                          <span>{String(index + 1).padStart(2, "0")}</span>
                          &nbsp;
                          {/* <span>{odc.Question}</span> */}
                          <span
                            className="cosubtitle text-truncate"
                            style={{ maxWidth: "300px" }}
                            title={odc.Question} 
                          >
                            {odc.Question}
                          </span>
                        </div>
                        <div
                          className="copara d-flex align-items-center"
                          style={{
                            fontFamily: "AvenirNextLTPro-Bold",
                            fontSize: "0.7rem",
                          }}
                        >
                          <img
                            src={corsevideo}
                            className="me-1"
                            alt="video icon"
                          />
                          {odc.Answer?.[0]?.courseTime} min
                        </div>
                      </div>
                      <hr className="coline mt-4 mb-4" />

                      {odc.Answer?.[0]?.answerText?.map((ans, idx) => (
                        <span
                          key={idx}
                          className="copara d-flex align-items-center mb-2"
                        >
                          <img
                            src={corseright}
                            className="me-2"
                            alt="right icon"
                          />
                          {ans}
                        </span>
                      ))}
                      <hr className="coline mt-4 mb-4" />

                      <div style={{ cursor: "pointer" }}>
                        <div className="d-flex justify-content-between">
                          <div className="d-flex gap-2 align-items-center">
                            <div>
                              {/* <img
                                src={
                                  IMG_PATH +
                                  odc.Answer?.[0]?.bookings?.[0]?.expertDetails
                                    ?.image
                                }
                                className="size-10 rounded-circle"
                                alt="Expert"
                              />
                            </div>
                            <div className="copara d-flex flex-column">
                              <span>
                                {
                                  odc.Answer?.[0]?.bookings?.[0]?.expertDetails
                                    ?.name
                                }
                              </span> */}
                              {/* <span>
                                {odc.Answer?.[0]?.bookings?.[0]?.chooseDate}
                              </span> */}

                              {/* {(() => {
  const tutor = getResolvedTutor(odc);
  if (!tutor) return null;

  const imgSrc = tutor.image?.startsWith("http")
    ? tutor.image
    : IMG_PATH + tutor.image;

  return (
    <>
      <img
        src={imgSrc}
        className="size-10 rounded-circle"
        alt="Expert"
      />

      <span>{tutor.name}</span>
    </>
  );
})()} */}

                              {/* {(() => {
  const tutor = getResolvedTutor(odc);
  if (!tutor) return null;

  const imgSrc = tutor.image?.startsWith("http")
    ? tutor.image
    : IMG_PATH + tutor.image;

  return (
    <div
      className="d-flex align-items-center"
      style={{ gap: "10px" }}
    >
      <img
        src={imgSrc}
        alt={tutor.name}
        className="rounded-circle"
        style={{
         
          width: 40,
          height: 40,
          objectFit: "cover",
        }}
      />

      <span
        style={{
          fontFamily: "AvenirNextLTPro-Bold",
          fontSize: "0.9rem",
          whiteSpace: "nowrap",
        }}
      >
        {tutor.name}
      </span>
    </div>
  );
})()} */}

                              {/* 
                              <span
  className="copara d-flex align-items-center"
  style={{
    cursor: 'pointer',
    fontFamily: 'AvenirNextLTPro-Bold',
    fontSize: '0.7rem',
    gap: '6px',
    marginLeft: '50px'
  }}
  onClick={() => {
    const loopId =
      getSessionKeyFromOD(odc) || odc?.Answer?.[0]?._id

    if (!loopId) return

    setAnsId(loopId)
    setChooseExpertSession(true)
    
  }}
>
  Change Tutor
  <img
    src={refresh}
    alt="change"
    style={{ width: '12px', height: '12px' }}
  />
</span> */}

                              {/* <div
  className="d-flex align-items-center"
  style={{ cursor: 'pointer', gap: '6px' }}
  onClick={() => {
    const loopId =
      getSessionKeyFromOD(odc) || odc?.Answer?.[0]?._id

    if (!loopId) return

    setAnsId(loopId)
    setChooseExpertSession(true)
  }}
>
  <img
    src={refresh}
    alt="change"
    style={{ width: '12px', height: '12px' , marginLeft: '50px'}}
  />
  <span
    className="copara"
    style={{
      fontFamily: 'AvenirNextLTPro-Bold',
      fontSize: '0.7rem',
    }}
  >
    Change Tutor
  </span>
</div> */}

                              {(() => {
                                const tutor = getResolvedTutor(odc);
                                if (!tutor) return null;

                                const imgSrc = tutor.image?.startsWith("http")
                                  ? tutor.image
                                  : IMG_PATH + tutor.image;

                                return (
                                  <div
                                    className="d-flex align-items-center"
                                    style={{ gap: "12px" }}
                                  >
                                    {/* Tutor Image */}
                                    <img
                                      src={imgSrc}
                                      alt={tutor.name}
                                      className="rounded-circle"
                                      style={{
                                        width: 40,
                                        height: 40,
                                        objectFit: "cover",
                                      }}
                                    />

                                    {/* Name + Change Tutor */}
                                    <div className="d-flex flex-column">
                                      <span
                                        style={{
                                          fontFamily: "AvenirNextLTPro-Bold",
                                          fontSize: "0.9rem",
                                          lineHeight: "1.1",
                                        }}
                                      >
                                        {tutor.name}
                                      </span>

                                      <div
                                        className="d-flex align-items-center"
                                        style={{
                                          cursor: "pointer",
                                          gap: "6px",
                                          marginTop: "4px",
                                        }}
                                        onClick={() => {
                                          const loopId =
                                            odc?.Answer?.[0]?._id;
                                          if (!loopId) return;
                                          setAnsId(loopId);
                                          setChooseExpertSession(true);
                                        }}
                                      >
                                        <img
                                          src={refresh}
                                          alt="change"
                                          style={{ width: 12, height: 12 }}
                                        />
                                        <span
                                          className="copara"
                                          style={{
                                            fontFamily: "AvenirNextLTPro-Bold",
                                            fontSize: "0.7rem",
                                          }}
                                        >
                                          Change Tutor
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                );
                              })()}
                            </div>
                          </div>
                          {/* <div className='copara d-flex align-items-center'> */}
                          {/* <img
                              src={viewnow}
                              style={{
                                width: '0.8rem',
                                height: '0.8rem',
                                marginRight: '0.2rem'
                              }}
                              alt='View Feedback Icon'
                            /> */}
                          {/* <span>View Feedback</span> */}
                          {/* <span>Start Loop Agian</span> */}
                          {/* <img
                              src={rightarrow}
                              style={{ width: '0.8rem', marginRight: '0.2rem' }}
                              alt='Right Arrow Icon'
                            />
                          </div> */}

                          <div
                            className="copara d-flex align-items-center"
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              if (!requireSubscriptionOnly()) return;
                              // const loopId =
                              //   odc?.Answer?.[0]?._id;

                              // if (!loopId) return;

                              // // ✅ reset loop completion ONLY
                              // handleRestartLoop(loopId);

                              // // ✅ clear any booking context (important)
                              // setAnsId("");
                              // setExpertId("");

                              // // ✅ start loop fresh
                              // startSessionloop(
                              //   odc?.loopSession,
                              //   filteredCourse[0]?.mySubject[0],
                              //   loopId,
                              //   odc,
                              // );
                              const loopId = odc?.Answer?.[0]?._id;

if (!loopId) return;

// ✅ VERY IMPORTANT: ensure tutor exists
const tutor = selectedTutors[loopId];

if (!tutor) {
  console.log("Tutor missing for loopId:", loopId);

  // optional: auto assign first tutor
  autoSelectFirstTutor(loopId);
}

// reset loop
handleRestartLoop(loopId);

setCurrentLoopId(loopId);
setCurrentOutlineDetail(odc);

startSessionloop(
  odc?.loopSession,
  filteredCourse[0]?.mySubject[0],
  loopId,
  odc
);
                            }}
                          >
                            <span>Start Loop Again</span>
                            <img
                              src={rightarrow}
                              style={{ width: "0.8rem", marginLeft: "4px" }}
                              alt="Right Arrow Icon"
                            />
                          </div>
                        </div>
                        {/* <hr className='coline mt-4 mb-4' />
                        <div className='d-flex justify-content-between'>
                          <div
                            onClick={() => ContactSupport(9)}
                            className='copara d-flex align-items-center'
                          >
                            <img
                              src={support}
                              style={{
                                width: '1.2rem',
                                height: '1.2rem',
                                marginRight: '0.2rem'
                              }}
                              alt='Support Icon'
                            />
                            <span style={{ color: '#7A0000' }}>
                              Contact Support
                            </span>
                          </div>
                          <div className='copara d-flex align-items-center'>
                            <img
                              src={watchnow}
                              style={{
                                width: '1rem',
                                height: '1rem',
                                marginRight: '0.2rem'
                              }}
                              alt='Watch Now Icon'
                            />
                            <span
                              onClick={() =>
                                watchNow(odc.Answer?.[0]?.bookings?.[0])
                              }
                            >
                              Watch now
                            </span>
                            <img
                              src={rightarrow}
                              style={{ width: '0.8rem', marginRight: '0.2rem' }}
                              alt='Right Arrow Icon'
                            />
                          </div>
                        </div> */}
                      </div>
                    </div>
                    <hr className="coline mt-5 mb-5" />
                  </div>
                ))}

                {normalizedOutlinedetails?.map((od, index) => {
                  // const sessionKey = od._id || ansId || od?.Answer?.[0]?._id;
                  const sessionKey =
                    od?.Answer?.[0]?._id;
                  return (
                    <div key={sessionKey || index}>
                      <div
                        className={`p-4 mb-3 rounded-3 ${
                          completedLoops.includes(sessionKey)
                            ? "completed-loop-card"
                            : "bg-white"
                        }`}
                        // style={{
                        //   backgroundColor: completedLoops.includes(sessionKey)
                        //     ? "#E8F5E8"
                        //     : "#FFFFFF",
                        //   border: completedLoops.includes(sessionKey)
                        //     ? "1px solid #2E7D32"
                        //     : "1px solid #DCE5DC",
                        // }}
                      >
                        <div className="d-flex justify-content-between align-items-center">
                          <div className="d-flex align-items-center gap-1">
                            <span className="cardindex">
                              {String(
                                index + outlinedetailscompleted.length + 1,
                              ).padStart(2, "0")}
                            </span>
                            &nbsp;
                            <span
                              className="cosubtitle text-truncate mr-2"
                              style={{ maxWidth: "300px" }}
                            >
                              {od.Question}
                            </span>
                          </div>

                          <div
                            className="copara text-nowrap d-flex align-items-center"
                            style={{
                              fontFamily: "AvenirNextLTPro-Bold",
                              fontSize: "0.7rem",
                            }}
                          >
                            <img
                              src={corsevideo}
                              className="me-1"
                              alt="video icon"
                            />
                            {od.Answer?.[0]?.courseTime || "N/A"} mins
                          </div>
                        </div>

                        <hr className="coline mt-4 mb-4" />

                        {od.Answer?.[0]?.answerText?.map((ans, idx) => (
                          <span
                            key={idx}
                            className="copara d-flex align-items-center mb-2"
                          >
                            <img
                              src={corseright}
                              className="me-2"
                              alt="right icon"
                            />
                            {ans}
                          </span>
                        ))}

                        <hr className="coline mt-4 mb-4" />

                        {od.Answer?.[0]?.bookings?.length > 0 ? (
                          <div style={{ cursor: "pointer" }}>
                            <div className="d-flex justify-content-between">
                              <div className="d-flex gap-2 align-items-center">
                                <img
                                  src={
                                    IMG_PATH +
                                    od.Answer?.[0]?.bookings?.[0]?.expertDetails
                                      ?.image
                                  }
                                  className="size-10 rounded-circle"
                                  alt="Expert"
                                />
                                <div className="copara">
                                  <span>
                                    {
                                      od.Answer?.[0]?.bookings?.[0]
                                        ?.expertDetails?.name
                                    }
                                  </span>
                                  <br />
                                  <span>
                                    {od.Answer?.[0]?.bookings?.[0]?.chooseDate}
                                  </span>
                                </div>
                              </div>

                              <div
                                className="d-flex align-items-center"
                                style={{
                                  cursor: "pointer",
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "6px",
                                }}
                                onClick={() => {
                                  setAnsId(sessionKey);
                                  setChooseExpertSession(true);
                                }}
                              >
                                <img
                                  src={refresh}
                                  alt="change"
                                  style={{
                                    width: "14px",
                                    height: "14px",
                                    display: "inline-block",
                                    verticalAlign: "middle",
                                    transform: "translateY(-1px)",
                                  }}
                                />

                                <span
                                  style={{
                                    fontFamily:
                                      "AvenirNextLTPro-Regular, Avenir Next, sans-serif",
                                    fontWeight: 500,
                                    fontSize: "10px",
                                    lineHeight: "10px",
                                    letterSpacing: "0px",
                                    color: "#000",
                                    display: "inline-flex",
                                    alignItems: "center",
                                  }}
                                >
                                  Change Tutor
                                </span>
                              </div>
                            </div>

                            <hr className="coline mt-4 mb-4" />

                            <div className="d-flex justify-content-between">
                              {/* <div
                                onClick={() =>
                                  openSignoutModal(
                                    od.Answer?.[0]?.bookings[0]?._id
                                  )
                                }
                                className='copara d-flex align-items-center'
                              >
                                <img
                                  src={rong}
                                  style={{
                                    width: '1rem',
                                    height: '1rem',
                                    marginRight: '0.2rem'
                                  }}
                                  alt='Cancel Icon'
                                />
                                <span style={{ color: '#7A0000' }}>
                                  Cancel Booking
                                </span>
                              </div> */}

                              {/* <div
                                onClick={() =>
                                  handleAddToCalendar(
                                    od.Answer?.[0]?.bookings[0]
                                  )
                                }
                                className='copara d-flex align-items-center'
                              >
                                <img
                                  src={calander}
                                  style={{
                                    width: '1rem',
                                    height: '1rem',
                                    marginRight: '0.2rem'
                                  }}
                                  alt='Calendar Icon'
                                />
                                <span>Add to Calendar</span>
                              </div> */}
                            </div>

                            <hr className="coline mt-4 mb-4" />
                          </div>
                        ) : (
                          <div className="d-flex justify-content-between align-items-center ">
                            <div className="d-flex align-items-center gap-2">
                              {selectedTutors?.[sessionKey] ? (
                                <div
                                  className="d-flex align-items-center"
                                  style={{ gap: "14px" }}
                                >
                                  {(() => {
                                    const img =
                                      selectedTutors[sessionKey].image || "";
                                    const src = img.startsWith?.("http")
                                      ? img
                                      : IMG_PATH + img;
                                    return (
                                      <img
                                        src={src}
                                        alt={selectedTutors[sessionKey].name}
                                        className="rounded-circle"
                                        style={{
                                          width: 48,
                                          height: 48,
                                          objectFit: "cover",
                                        }}
                                      />
                                    );
                                  })()}

                                  <div
                                    className="d-flex flex-column"
                                    style={{ lineHeight: 1.2 }}
                                  >
                                    <span
                                      style={{
                                        fontWeight: 600,
                                        fontSize: "0.9rem",
                                        className: "copara",
                                      }}
                                    >
                                      {selectedTutors[sessionKey].name}
                                    </span>
                                    <div
                                      className="d-flex align-items-center"
                                      style={{
                                        gap: "8px",
                                        cursor: "pointer",
                                        marginTop: "2px",
                                      }}
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        setAnsId(sessionKey);
                                        setChooseExpertSession(true);
                                      }}
                                    >
                                      <img
                                        src={refresh}
                                        style={{ width: 16, height: 16 }}
                                        alt="change"
                                      />
                                      <span
                                        className="copara"
                                      >
                                        Change Tutor
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              ) : (
                                /* Choose Tutor fallback */
                                <span
                                  // onClick={() => {
                                  //   const keyForModal =
                                  //     sessionKey ||
                                  //     od?.Answer?.[0]?._id ||
                                  //     ansId;
                                  //   setAnsId(keyForModal);
                                  //   handleOpenTutorModal();
                                  // }}
                                  onClick={() => {
                                    const keyForModal =
                                      od?.Answer?.[0]?._id;
                                    setAnsId(keyForModal);
                                    // autoSelectFirstTutor(keyForModal);
                                    handleOpenTutorModal();
                                  }}
                                  className="copara"
                                  style={{
                                    fontFamily: "AvenirNextLTPro-Bold",
                                    fontSize: "0.7rem",
                                    cursor: "pointer",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 6,
                                  }}
                                >
                                  Choose a Tutor
                                  <img
                                    style={{ width: 10, height: 10 }}
                                    src={arrowwhite}
                                    alt="arrow"
                                  />
                                </span>
                              )}
                            </div>

                            {od?.loopSession && (
                              <div className="d-flex align-items-center">
                                {!selectedTutors?.[sessionKey] && (
                                  <img
                                    src={lockIcon}
                                    alt="locked"
                                    style={{
                                      width: 20,
                                      height: 20,
                                      cursor: "not-allowed",
                                      opacity: 1,
                                      pointerEvents: "none",
                                      transform: "translateY(-1px)",
                                    }}
                                  />
                                )}

                                {selectedTutors?.[sessionKey] &&
                                  (completedLoops.includes(sessionKey) ? (
                                    <button
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleRestartLoop(sessionKey);
                                      }}
                                      style={{
                                        backgroundColor: "transparent",
                                        border: "none",
                                        fontWeight: 600,
                                        fontSize: "0.8rem",
                                        cursor: "pointer",
                                        // textDecoration: 'underline',
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "4px",
                                        marginLeft: 8,
                                      }}
                                    >
                                      Start Loop Again
                                      <img
                                        src={arrowwhite}
                                        alt="arrow"
                                        style={{ width: 10, height: 10 }}
                                      />
                                    </button>
                                  ) : (
                                    <div
                                    className="startLoopBtn"
                                     
                                  
                                      onClick={() => {
                                        if (!registerid) {
                                          window.dispatchEvent(
                                            new Event("recess:openSignIn"),
                                          );
                                          navigate("/", { state: true });
                                          return;
                                        }

                                        if (!isSubscribed) {
                                          setSubscriptionModal(true);
                                          return;
                                        }

                                        startSessionloop(
                                          od?.loopSession,
                                          filteredCourse[0]?.mySubject[0],
                                          sessionKey,
                                          od,
                                        );
                                      }}
                                    >
                                      Start Loop
                                      <img
                                        src={arrowwhite}
                                        alt="arrow"
                                        style={{
                                          width: 10,
                                          height: 10,
                                          marginLeft: 4,
                                        }}
                                      />
                                    </div>
                                  ))}
                              </div>
                            )}
                          </div>
                        )}
                      </div>

                      <hr className="coline mt-5 mb-5" />
                    </div>
                  );
                })}

                {/* course pending  ended */}

                {/* {accept_badge_url !== undefined ? ( */}

                {badgeMessage && (
                  <div
                    className="copara mb-2"
                    style={{
                      color: "#7A0000",
                      fontSize: "0.75rem",
                      textAlign: "center",
                    }}
                  >
                    {badgeMessage}
                  </div>
                )}

                <div className="mb-4">
                  <div className="mb-4">
                    <div
                      className={`${
                        isCourseCompleted(CoursecompletionRatio)
                          ? "coursecompletedgreen-bg"
                          : "coursecompleted"
                      } hover:border-black`}
                    >
                      <div
                        className="d-flex justify-content-between align-items-center"
                        onClick={handleViewBadge}
                      >
                        {/* Left side: Course Completion and award image */}
                        <div className="d-flex align-items-center gap-2">
                          <img src={award} alt="Award" />
                          <div style={{ fontSize: "1rem" }}>
                            View your badge
                          </div>
                        </div>

                        {/* Right side: arrowwhite icon */}
                        <img
                          style={{ width: "1.1rem", height: "1.1rem" }}
                          src={arrowwhite}
                          alt="Arrow"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <CardFooter className="mt-auto">
        <Line />
        <Footer />
      </CardFooter>

      {/* <Modal
        centered
        show={chooseExpertSession}
        className="flex items-center m-0 rad"
      >
        <Modal.Body className="modalbackgroundcolor  items-center rounded-lg">
          <Modal.Header
            className="btn btn-close ms-auto"
            onClick={() => setChooseExpertSession(false)}
          />
          <div className="p-2">
            <p className="cotitle2">Choose a Tutor</p>
            <hr className="coline" />
            <p className="copara mb-3 mt-3">
              If you'd like to learn more about an tutor before deciding, we
              suggest checking out their profiles and booking an intro session
              to see if they're the right fit.
            </p>
            <hr className="coline" />
            <div
              style={{
                overflowY: "scroll",
                height: "300px",
                scrollbarWidth: "none",
              }}
            >
              {!cardDetails || cardDetails.length === 0 ? (
                <div className="text-center mt-5 ">
                  <h5 className="mt-5 card-title-favorite">No Tutors Found</h5>
                </div>
              ) : (
                cardDetails
                  .filter((details) => details.user_id !== registerid)
                  .map((carddetail, index) => (
                    <div className="mb-2 mt-2  choose-tutor-modal">
                      <TutorCard
                        key={index}
                        details={carddetail}
                        registerid={registerid}
                        updateBookmarkInParent={updateBookmarkInParent}
                        // handleBookSession={handleBookSession}
                        // handleBookSession={(carddetail) => handleBookSession(carddetail, od)} // Pass the session data
                        // handleBookSession={(carddetail) =>
                        //   handleBookSession(
                        //     carddetail,
                        //     outlinedetails.find(
                        //       (od) => getSessionKeyFromOD(od) === ansId
                        //     )
                        //   )
                        // }

                        handleBookSession={(carddetail) =>
                          handleBookSession(carddetail, ansId)
                        }
                        choosebutton={true}
                        NextAvailableSlot={NextAvailableSlot}
                        isSubscribed={isSubscribed}
                        setSubscriptionModal={setSubscriptionModal}
                      />
                    </div>
                  ))
              )}
            </div>
          </div>
        </Modal.Body>
      </Modal> */}

      <Modal
  centered
  show={chooseExpertSession}
  className="flex items-center m-0 rad"
>
  <Modal.Body className="modalbackgroundcolor items-center rounded-lg">
    
    {/* TOP ROW FIX (title + close button same line) */}
    <div className="d-flex justify-content-between align-items-center px-2 pt-2">
      <p className="cotitle2 m-0">Choose a Tutor</p>
      <button
        type="button"
        className="btn-close"
        onClick={() => setChooseExpertSession(false)}
      ></button>
    </div>

    <div className="p-2">
      <hr className="coline" />

      <div
        style={{
          overflowY: "scroll",
          height: "300px",
          scrollbarWidth: "none",
        }}
      >
        {!cardDetails || cardDetails.length === 0 ? (
          <div className="text-center mt-5">
            <h5 className="mt-5 card-title-favorite">No Tutors Found</h5>
          </div>
        ) : (
          cardDetails
            .filter((details) => details.user_id !== registerid)
            .map((carddetail, index) => (
              <div key={index} className="mb-2 mt-2 choose-tutor-modal">
                <TutorCard
                  details={carddetail}
                  registerid={registerid}
                  updateBookmarkInParent={updateBookmarkInParent}
                  handleBookSession={(carddetail) =>
                    handleBookSession(carddetail, ansId)
                  }
                  choosebutton={true}
                  NextAvailableSlot={NextAvailableSlot}
                  isSubscribed={isSubscribed}
                  setSubscriptionModal={setSubscriptionModal}
                />
              </div>
            ))
        )}
      </div>
    </div>

  </Modal.Body>
</Modal>

      {/* calander modal started */}
      <Modal
        centered
        show={calanderModal}
        className="flex items-center m-0 rad"
      >
        <ModalBody className="modalbackgroundcolor  p-4 items-center rounded-lg">
          <div className="d-flex justify-content-between">
            <span
              onClick={() => {
                setCalanderModal(false);
                setChooseExpertSession(true);
              }}
              style={{
                fontFamily: "AvenirNextLTPro-Bold",
                fontSize: "0.8rem",
                cursor: "pointer",
              }}
              className="d-flex align-items-center"
            >
              <img src={leftarrow} style={{ width: "0.8rem" }} />
              Back
            </span>
            <span
              className="btn btn-close ms-auto"
              onClick={() => setCalanderModal(false)}
            ></span>
          </div>

          <div>
            <dl>
              <dd className="cotitle2 fs-5 mt-3">Book a session</dd>
              <dd className="copara">With {particularExpertName}</dd>
              {/*  */}
              <div
                style={{
                  overflowY: "scroll",
                  height: "350px",
                  scrollbarWidth: "none",
                }}
              >
                <dd
                  style={{
                    marginTop: "20px",
                    backgroundColor: "#F5F3EE",
                    borderRadius: "15px",
                    boxShadow: "0px 4px 4px 0px #00000040",
                    border: "2px solid black",
                  }}
                >
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DateCalendar
                      className="custom-calendar"
                      value={selectedDate ? dayjs(selectedDate) : null}
                      onChange={(newDate) =>
                        setSelectedDate(newDate?.format("YYYY-MM-DD"))
                      }
                      minDate={today}
                      maxDate={maxDate}
                      shouldDisableDate={(date) => {
                        const dayOfWeek = dayjs(date).format("dddd");
                        return !disabledDays.includes(dayOfWeek);
                      }}
                      dayOfWeekFormatter={(day) => {
                        const dayIndex = day.day();
                        const dayLabels = [
                          "Su",
                          "Mo",
                          "Tu",
                          "We",
                          "Th",
                          "Fr",
                          "Sa",
                        ];
                        return dayLabels[dayIndex];
                      }}
                    />
                  </LocalizationProvider>
                </dd>
                {/*  */}
                <div>
                  <div className="d-flex justify-between align-items-center mt-3">
                    <div className="cotitle2">Choose a time</div>
                    <div
                      className="copara d-flex justify-content-end"
                      style={{
                        fontFamily: "AvenirNextLTPro-Bold",
                        fontSize: "0.8rem",
                        cursor: "pointer",
                      }}
                    >
                      <span
                        className="d-flex align-items-center me-4"
                        onClick={handlePrev}
                      >
                        <img src={leftarrow} alt="Previous" />
                        Prev
                      </span>
                      <span
                        className="d-flex align-items-center"
                        onClick={handleNext}
                      >
                        Next
                        <img src={rightarrow} alt="Next" />
                      </span>
                    </div>
                  </div>

                  <div className="d-flex flex-wrap mb-5">
                    {currentSlots?.map(
                      (daySlot, index) =>
                        !hideSlots.includes(daySlot.timing) && (
                          <div key={index} className="col-3 ps-2 mb-2  ">
                            <input
                              readOnly
                              value={daySlot.timing.split(" - ")[0]}
                              type="text"
                              className="mt-3 coinput"
                              onClick={() =>
                                handleInputClick(index, daySlot.timing)
                              }
                              style={{
                                backgroundColor:
                                  selectedInputIndex === index
                                    ? "black"
                                    : "#F5F3EE",
                                color:
                                  selectedInputIndex === index
                                    ? "white"
                                    : "#000000",
                              }}
                            />
                          </div>
                        ),
                    )}
                  </div>
                </div>
                {/*  */}
                <button
                  className="cobooknowbutton mb-3"
                  onClick={() => bookexpert()}
                >
                  Book now
                </button>
              </div>
            </dl>
          </div>
        </ModalBody>
      </Modal>
      {/* related to past ended */}

      <Modal centered show={signout} className="modal">
        <Modal.Body
          className="modalbackgroundcolor modalhightandwidth"
          style={{ width: "512px", height: "227px" }}
        >
          <p style={{ textAlign: "center" }} className="pass">
            Are you sure you want to Cancel Session?
          </p>
          <div className="d-flex justify-content-center mb-5">
            <Button
              style={{ fontFamily: "AvenirNextLTPro-Regular" }}
              variant="dark"
              onClick={() => {
                cancelBooking(bookingIdToCancel);
              }}
              className=" passbutton"
            >
              Yes
            </Button>
            <Button
              style={{ fontFamily: "AvenirNextLTPro-Regular" }}
              variant="dark"
              onClick={closeSignoutModal}
              className="ms-3 passbutton"
            >
              No
            </Button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={sessionloop}
        onHide={() => setSessionloop(false)}
        backdrop="static"
        keyboard={false}
        fullscreen
        className="fullscreen-modal flex items-center m-0 rad"
      >
        <Modal.Body className="sessionloop-body">
          {/* <Loopsession
            closeModal={() => setSessionloop(false)}
            loopSession={loopSession}
            courseId={courseId}
            subject={loopSubject}
            keytools={filteredKeytools}
            onLoopComplete={handleLoopComplete}
            loopId={currentLoopId}
            selectedTutor={selectedTutors?.[currentLoopId] ?? null}
            currentOutlineDetail={currentOutlineDetail}
          /> */}
          <Loopsession
            closeModal={() => setSessionloop(false)}
            loopSession={loopSession}
            courseId={courseId}
            subject={loopSubject}
            keytools={filteredKeytools}
            onLoopComplete={handleLoopComplete}
            loopId={currentLoopId}
            // NEW props:
            selectedTutorId={selectedTutors?.[currentLoopId]?.expertId ?? null}
           
            answerId={
              // prefer explicit Answer._id from the outline detail,
              // otherwise fallback to currentLoopId (if that's the Answer id)
              currentOutlineDetail?.Answer?.[0]?._id || null
            }
            selectedTutor={selectedTutors?.[currentLoopId] ?? null}
            currentOutlineDetail={currentOutlineDetail}
          />
        </Modal.Body>
      </Modal>

      <CourseOutlineModule name={modalname} coursename={coursename} />

      {!isSubscribed && (
        <SettingSubscription
          subscriptionModal={subscriptionModal}
          setSubscriptionModal={setSubscriptionModal}
        />
      )}
    </div>
  );
};
export default CourseOutline;

{
  /* <hr className="coline mb-4" /> */
}
{
  /* <p className="copara">
                  A collection of materials and resources you can access anytime to
                  help you throughout your course.
                </p>
                <hr className="coline" /> */
}
{
  /* <span
                  onClick={() => {
                    setModalName("");
                    setTimeout(() => setModalName("coursekit"), 0);
                  }}
                  style={{
                    fontFamily: "AvenirNextLTPro-Bold",
                    fontSize: "0.7rem",
                    cursor: "pointer",
                  }}
                  className="copara ms-2 d-flex align-items-center"
                >
                  Access now{" "}
                  <img
                    style={{ width: "0.6rem", height: "0.6rem" }}
                    src={rightarrow}
                  />
                </span> */
}
